import * as Api from '@ViewModels';
import { css } from 'aphrodite';
import * as React from 'react';
import { useSingleEmailComposer, useUserSession } from '../../../../../models/hooks/appStateHooks';
import { white } from '../../../../styles/colors';
import { DetailsFlyout } from '../../../DetailsFlyout';
import { styleSheet as flyoutStyleSheet } from '../../../DetailsFlyout/styles';
import { EntityChip } from '../../../chips/EntityChip';
import { EmailIcon } from '../../../svgs/icons/EmailIcon';
import { formatServiceJobCurrency, formatServiceJobDate } from '../utils';
import { styleSheet } from './styles';

export const ServiceJobDetailsFlyout = ({
	isOpen,
	setIsOpen,
	job,
}: {
	isOpen: boolean;
	setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
	job: Api.IServiceJob;
}) => {
	const userSession = useUserSession();
	const singleEmailComposer = useSingleEmailComposer();

	const sendEmail = () => {
		if (job.contact) {
			const contactVm = new Api.ContactViewModel(userSession, job.contact);
			singleEmailComposer.showForRecipients([contactVm]);
		}
	};

	return (
		<DetailsFlyout isOpen={isOpen} setIsOpen={setIsOpen} title='Service Job Details'>
			<div className={css(styleSheet.container)}>
				<section className={css(styleSheet.section)}>
					<h4 className={css(flyoutStyleSheet.subTitle)}>{job.summary || job.jobNumber}</h4>
					{job.summary ? <small>#{job.jobNumber}</small> : null}
				</section>

				{job.contact ? (
					<section className={css(styleSheet.section)}>
						<span className={css(styleSheet.label)}>Contact</span>
						<EntityChip
							entity={new Api.ContactViewModel(userSession, job.contact)}
							readOnly={true}
							sizeConstraint='compact'
						/>
					</section>
				) : null}

				{job.contact?.primaryEmail?.value ? (
					<section className={css(styleSheet.quickActions)}>
						<a className={css(styleSheet.quickActionButton)} onClick={sendEmail}>
							<EmailIcon fillColor={white} width={16} height={14} />
						</a>
					</section>
				) : null}

				<div className={css(flyoutStyleSheet.separator)} />

				<section className={css(styleSheet.detailsSection)}>
					<div className={css(styleSheet.detailRow)}>
						<span className={css(styleSheet.label)}>Job Number</span>
						<span className={css(styleSheet.value)}>{job.jobNumber || '-'}</span>
					</div>

					<div className={css(styleSheet.detailRow)}>
						<span className={css(styleSheet.label)}>Status</span>
						<span className={css(styleSheet.value)}>{job.jobStatus?.name || '-'}</span>
					</div>

					<div className={css(styleSheet.detailRow)}>
						<span className={css(styleSheet.label)}>Total</span>
						<span className={css(styleSheet.value)}>{formatServiceJobCurrency(job.total)}</span>
					</div>

					<div className={css(styleSheet.detailRow)}>
						<span className={css(styleSheet.label)}>Completed On</span>
						<span className={css(styleSheet.value)}>{formatServiceJobDate(job.completedOn)}</span>
					</div>

					{job.source ? (
						<div className={css(styleSheet.detailRow)}>
							<span className={css(styleSheet.label)}>Source</span>
							<span className={css(styleSheet.value)}>{job.source}</span>
						</div>
					) : null}
				</section>
			</div>
		</DetailsFlyout>
	);
};
